import { FetchPermissionsRequest } from './../roles.actions'
import { getPermissionsState } from './../roles.selectors'
import {
  SetDefaultData,
  FetchRoleRequest,
  UpdateField,
  UpdateRoleRequest,
} from '../roles.actions'
import { getUpdateRoleState } from '../roles.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnDestroy, OnInit } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription, Observable } from 'rxjs'
import { Map } from 'immutable'
import { groupPermissions } from '@shared/shared.utils'

@Component({
  selector: 'app-update-role',
  templateUrl: './update-role.component.html',
  styleUrls: ['./update-role.component.css'],
})
export class UpdateRoleComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  public roleId: number
  public permissions$: Subscription
  public permissionGroups: any[] = []

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.permissions$.unsubscribe()
  }

  ngOnInit() {
    this.roleId = parseInt(this.route.snapshot.paramMap.get('id'), 10)
    this.store.dispatch<any>(new SetDefaultData('updateRole'))
    this.state$ = this.store
      .pipe(select(getUpdateRoleState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })
    this.permissions$ = this.store
      .pipe(select(getPermissionsState))
      .subscribe((state) => {
        this.permissionGroups = groupPermissions(state.get('data').toJS())
      })

    this.store.dispatch<any>(new FetchRoleRequest(this.roleId))
    this.store.dispatch<any>(new FetchPermissionsRequest())
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'updateRole.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'updateRole',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
      title: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public checkboxChange(e: any): void {
    let permissions = (this.state.getIn(['data', 'permissions']) as any).toJS()

    if (e.target.checked) {
      permissions.push(e.target.value)
    } else {
      permissions = permissions.filter(
        (perm: string) => perm !== e.target.value,
      )
    }

    this.store.dispatch(
      new UpdateField('permissions', permissions, 'updateRole.data'),
    )
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateRoleRequest(this.roleId, payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateRole',
        ),
      )
    }
  }
}
